import React from "react";
import { Box, Button, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ExternalInfoRow from "./ExternalInfoRow";
import { useSelector, useDispatch } from "react-redux";
import { addExternalInfo } from "features/OrgAdmin/orgAdminSlice";

export default function ExternalInfoForm() {
  const dispatch = useDispatch();
  const externalInfo = useSelector((state) => state.org.externalInfo);

  const handleAdd = () => {
    dispatch(addExternalInfo());
  };

  return (
    <Box sx={{ mt: 3, mb: 3, display: "flex", width: "100%", alignItems: "flex-start" }}>
      {/* Label aligned to the left */}
      <Box sx={{ width: "140px", mt: 1 }}>
        <Typography 
          variant="body2" 
          sx={{ color: "#333", fontSize: "0.85rem", fontWeight: 600 }}
        >
          External Info :
        </Typography>
      </Box>

      {/* Rows and Button container stretching to fill the remaining space */}
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 1.5 }}>
        {externalInfo.map((data, index) => (
          <ExternalInfoRow key={index} index={index} data={data} />
        ))}

        <Button
          variant="outlined"
          onClick={handleAdd}
          startIcon={<AddIcon />}
          sx={{
            width: "100%", 
            borderStyle: "dashed",
            borderWidth: "1px",
            borderColor: "#d1d5db",
            color: "#6b7280",
            textTransform: "none",
            py: 1,
            mt: 0.5,
            borderRadius: "6px",
            justifyContent: "center",
            "&:hover": { 
              borderStyle: "dashed", 
              borderColor: "#9ca3af",
              backgroundColor: "#f9fafb" 
            }
          }}
        >
          Add External Info
        </Button>
      </Box>
    </Box>
  );
}